'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChildAvailabilityItem, ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import { useChildSponsorship } from '../../../hooks/useChildSponsorship.ts';
import { ChildBioDetailsHeading } from '../../../molecules/child-bio-details/child-bio-details-heading.tsx';
import { ChildBioInfo } from '../../../molecules/child-bio-details/child-bio-info.tsx';
import { SubmitButton } from '../../../molecules/child-bio-details/child-bio-sponsorship-submit-button.tsx';
import { ChildBioSummary } from '../../../molecules/child-bio-details/child-bio-summary.tsx';
import { ChildBioImage } from '../../../molecules/child-bio-image/child-bio-image.tsx';
type HelpMeChooseResultProps = {
  childDetails?: ChildDetails;
  childAvailability: ChildAvailabilityItem;
};
export const HelpMeChooseResult: React.FC<HelpMeChooseResultProps> = t0 => {
  const $ = _c(42);
  const {
    childDetails,
    childAvailability
  } = t0;
  const globalId = childDetails?.globalId ?? childAvailability.globalId;
  const {
    isSubmitting,
    bioErrors,
    handleSponsorshipSubmit
  } = useChildSponsorship(globalId);
  if (!childDetails) {
    let t1;
    if ($[0] !== childAvailability.name.preferred) {
      t1 = <div className="ChildBio__media flex-1 align-start"><h2 className="ChildBioDetails__heading heading-potent heading-xl mb-comfy-sm">{childAvailability.name.preferred}</h2></div>;
      $[0] = childAvailability.name.preferred;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== childAvailability.name.first || $[3] !== childAvailability.name.preferred) {
      t2 = {
        name: childAvailability.name.first,
        preferred: childAvailability.name.preferred
      };
      $[2] = childAvailability.name.first;
      $[3] = childAvailability.name.preferred;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== childAvailability || $[6] !== t2) {
      t3 = {
        ...childAvailability,
        hangul: t2
      };
      $[5] = childAvailability;
      $[6] = t2;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    const t4 = t3 as unknown as ChildDetails;
    let t5;
    if ($[8] !== bioErrors || $[9] !== handleSponsorshipSubmit || $[10] !== isSubmitting || $[11] !== t4) {
      t5 = <div className="ChildBio__summary flex flex-col flex-1 gap-comfy-sm sm:gap-0 sm:pt-0"><SubmitButton className="order-2 sm:order-last" bioErrors={bioErrors} details={t4} isSubmitting={isSubmitting} handleSponsorshipSubmit={handleSponsorshipSubmit} /></div>;
      $[8] = bioErrors;
      $[9] = handleSponsorshipSubmit;
      $[10] = isSubmitting;
      $[11] = t4;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    let t6;
    if ($[13] !== t1 || $[14] !== t5) {
      t6 = <div className="HelpMeChooseResult"><div className="ChildBio ChildBio__flex flex flex-col"><div className="ChildBio__content flex flex-col sm:flex-row gap-comfy-sm sm:gap-comfy-xl">{t1}{t5}</div></div></div>;
      $[13] = t1;
      $[14] = t5;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    return t6;
  }
  let t1;
  if ($[16] !== childDetails) {
    t1 = <div className="sm:hidden"><ChildBioDetailsHeading seoLevel={2} details={childDetails} /></div>;
    $[16] = childDetails;
    $[17] = t1;
  } else {
    t1 = $[17];
  }
  let t2;
  if ($[18] !== childAvailability || $[19] !== childDetails) {
    t2 = <ChildBioImage details={childDetails} availability={childAvailability} />;
    $[18] = childAvailability;
    $[19] = childDetails;
    $[20] = t2;
  } else {
    t2 = $[20];
  }
  let t3;
  if ($[21] !== t1 || $[22] !== t2) {
    t3 = <div className="ChildBio__media flex-1 align-start">{t1}{t2}</div>;
    $[21] = t1;
    $[22] = t2;
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  let t4;
  let t5;
  if ($[24] !== childDetails) {
    t4 = <div className="hidden sm:block"><ChildBioDetailsHeading seoLevel={2} details={childDetails} /></div>;
    t5 = <ChildBioSummary className="mb-0 sm:pb-comfy-sm text-sm order-1" details={childDetails} />;
    $[24] = childDetails;
    $[25] = t4;
    $[26] = t5;
  } else {
    t4 = $[25];
    t5 = $[26];
  }
  let t6;
  if ($[27] !== bioErrors || $[28] !== childDetails || $[29] !== handleSponsorshipSubmit || $[30] !== isSubmitting) {
    t6 = <SubmitButton className="order-2 sm:order-last" bioErrors={bioErrors} details={childDetails} isSubmitting={isSubmitting} handleSponsorshipSubmit={handleSponsorshipSubmit} />;
    $[27] = bioErrors;
    $[28] = childDetails;
    $[29] = handleSponsorshipSubmit;
    $[30] = isSubmitting;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  let t7;
  if ($[32] !== childDetails) {
    t7 = <div className="order-3 sm:pb-comfy-xl"><ChildBioInfo details={childDetails} /></div>;
    $[32] = childDetails;
    $[33] = t7;
  } else {
    t7 = $[33];
  }
  let t8;
  if ($[34] !== t4 || $[35] !== t5 || $[36] !== t6 || $[37] !== t7) {
    t8 = <div className="ChildBio__summary flex flex-col flex-1 gap-comfy-sm sm:gap-0 sm:pt-0">{t4}{t5}{t6}{t7}</div>;
    $[34] = t4;
    $[35] = t5;
    $[36] = t6;
    $[37] = t7;
    $[38] = t8;
  } else {
    t8 = $[38];
  }
  let t9;
  if ($[39] !== t3 || $[40] !== t8) {
    t9 = <div className="HelpMeChooseResult"><div className="ChildBio ChildBio__flex flex flex-col"><div className="ChildBio__content flex flex-col sm:flex-row gap-comfy-sm sm:gap-comfy-xl">{t3}{t8}</div></div></div>;
    $[39] = t3;
    $[40] = t8;
    $[41] = t9;
  } else {
    t9 = $[41];
  }
  return t9;
};